import React from 'react';
import { Button, Typography, useTheme, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/pro-duotone-svg-icons';

export type UploadButtonProps = {
    fileInputRef: React.RefObject<HTMLLabelElement>;
    smallUploadableBtn?: boolean;
};

const UploadButton: React.FunctionComponent<UploadButtonProps> = function (props) {
    const { fileInputRef, smallUploadableBtn = false } = props;
    const { palette } = useTheme();

    const uploadActionSx = {
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
        gap: '0 5px',
        fontSize: '14px',
        lineHeight: '17px',
        fontWeight: '500',
    };

    const uploadActionBtnSx = {
        padding: '0',
        fontSize: '14px',
        lineHeight: '17px',
        fontWeight: '500',
        color: `${palette.primary.dark}`,
    };

    return (
        <Typography
            component="p"
            sx={uploadActionSx}
        >
            {smallUploadableBtn ? (
                <Box sx={{ padding: '0 8px' }}>
                    <FontAwesomeIcon
                        icon={faCloudArrowUp}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            fileInputRef?.current?.click();
                        }}
                    />
                </Box>
            ) : (
                <Box sx={{ display: 'flex', gap: '0 5px' }}>
                    <Button
                        data-testid="upload-btn"
                        sx={uploadActionBtnSx}
                        variant="text"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            fileInputRef?.current?.click();
                        }}
                    >
                        Sélectionnez
                    </Button>
                    <Typography>ou glissez ici </Typography>
                </Box>
            )}
        </Typography>
    );
};

export default UploadButton;
